"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = require("debug");
var decorate_component_with_props_1 = require("decorate-component-with-props");
var draft_js_plugin_editor_toolbar_picker_1 = require("draft-js-plugin-editor-toolbar-picker");
var link_1 = require("./component/link");
var link_sub_menu_1 = require("./component/link-sub-menu");
var link_trigger_button_1 = require("./component/link-trigger-button");
var link_entity_util_1 = require("./util/link-entity-util");
var styled_1 = require("./component/styled");
exports.Anchor = styled_1.Anchor;
exports.URLInput = styled_1.URLInput;
exports.URLInputWrapper = styled_1.URLInputWrapper;
var d = debug_1.default('draft-js-toolbar-link-plugin:example');
function createToolbarLinkPlugin(options) {
    options = options || {};
    var inputTheme = options.inputTheme, inputPlaceholder = options.inputPlaceholder, inputComponent = options.inputComponent, inputWrapperComponent = options.inputWrapperComponent, linkTheme = options.linkTheme, linkComponent = options.linkComponent, linkTarget = options.linkTarget;
    var pluginFunctions;
    var isLinkActive = function () {
        if (!pluginFunctions) {
            return false;
        }
        return link_entity_util_1.isCurrentEntityLink(pluginFunctions.getEditorState());
    };
    var LinkButton = draft_js_plugin_editor_toolbar_picker_1.default({
        triggerItem: decorate_component_with_props_1.default(link_trigger_button_1.default, { styleIsActive: isLinkActive }),
        items: [
            decorate_component_with_props_1.default(link_sub_menu_1.default, {
                urlInputTheme: inputTheme,
                inputPlaceholder: inputPlaceholder,
                inputComponent: inputComponent,
                wrapperComponent: inputWrapperComponent,
                requestEditorFocus: function () {
                    if (pluginFunctions && pluginFunctions.getEditorRef) {
                        var editor = pluginFunctions.getEditorRef();
                        editor.focus();
                    }
                }
            })
        ]
    });
    var handleLinkClick = function (e, url) {
        if (pluginFunctions) {
            var getReadOnly = pluginFunctions.getReadOnly;
            if ((!getReadOnly || !getReadOnly()) && (e.metaKey || e.ctrlKey)) {
                e.stopPropagation();
                e.preventDefault();
                window.open(url, linkTarget || 'blank');
            }
        }
    };
    return {
        initialize: function (fns) {
            pluginFunctions = fns;
        },
        decorators: [{
                strategy: link_entity_util_1.findLinkEntityRanges,
                component: decorate_component_with_props_1.default(link_1.default, {
                    onClick: handleLinkClick,
                    theme: linkTheme,
                    anchorComponent: linkComponent,
                    target: linkTarget
                })
            }],
        LinkButton: LinkButton
    };
}
exports.default = createToolbarLinkPlugin;
